var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-responsive app-logo",attrs:{"src":require("@/assets/img/logo.png"),"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }